<template>
    <div class="doc-section">
        <h2>Deshabilitar usuario</h2>

        <plataformaNavegacion @cambio-plataforma="actualizarVista" />

        <p>
            En la tabla de usuarios, hacer clic sobre el botón de deshabilitar, el sistema mostrará una ventana
            emergente con el mensaje ¿Está seguro que desea deshabilitar el usuario?, hacer clic en el botón “Aceptar”
            para deshabilitar el usuario o en “Cancelar” para no deshabilitar el usuario.
        </p>
        <div v-if="plataforma === 'web'" class="platform-content">
            <CarruselAciqui :items="imagenesEditarUsuario.slice(0,2)" />
        </div>
         <div v-if="plataforma === 'moviles'" class="platform-content">
            <CarruselAciqui :items="imagenesEditarUsuarioMoviles.slice(0,2)" />
        </div>

        <h2>
            Habilitar usuario
        </h2>
        <p>
            En la tabla de usuarios, hacer clic sobre el botón de habilitar, el sistema mostrará una ventana emergente con el mensaje ¿Está seguro que desea habilitar el usuario?, hacer clic en el botón “Aceptar” para habilitar el usuario o en  “Cancelar” para no habilitar el usuario.ación en la parte superior derecha de sistema como la siguiente.
        </p>
            <div v-if="plataforma === 'web'" class="platform-content">
                <CarruselAciqui :items="imagenesEditarUsuario.slice(2,4)" />
            </div>
             <div v-if="plataforma === 'moviles'" class="platform-content">
                <CarruselAciqui :items="imagenesEditarUsuarioMoviles.slice(2,4)" />
            </div>


        <div class="info-card">
            <p>
                <strong>Mensaje de exito: </strong>
                Al Habilitar/Deshabilitar el usuario exitosamente se mostrará una notificación en la parte superior
                derecha de sistema
            </p>
        </div>

    </div>
</template>

<script>
import CarruselAciqui from '../Carruselimg.vue';
import plataformaNavegacion from '../BotonesNavegacion.vue';

export default {
    name: 'EstatusUsuario',
    components: { CarruselAciqui,plataformaNavegacion },
    data: () => ({
        plataforma: 'web',
        imagenesEditarUsuario: [
            {
                nombre: "Deshabilitar usuario",
                url: "img/usuarios/deshabilitarUsuario.png",
                descripcion: "Mensaje de confirmación para deshabilitar un usuario"
            },
            {
                nombre: "Mensaje de exito al deshabilitar",
                url: "img/usuarios/exitoDeshabilitar.png",
                descripcion: ""
            },
            {
                nombre: "Habilitar usuario",
                url: "img/usuarios/habilitarUsuario.png",
                descripcion: "Mensaje de confirmación para habilitar un usuario"
            },
            {
                nombre: "Mensaje de exito al deshabilitar",
                url: "img/usuarios/exitoHabilitar.png",
                descripcion: ""
            }
        ],
        imagenesEditarUsuarioMoviles: [
            {
                nombre: "Deshabilitar usuario",
                url: "img/usuarios/moviles/deshabilitarUsuario.png",
                descripcion: "Mensaje de confirmación para deshabilitar un usuario"
            },
            {
                nombre: "Mensaje de exito al deshabilitar",
                url: "img/usuarios/exitoDeshabilitar.png",
                descripcion: ""
            },
            {
                nombre: "Habilitar usuario",
                url: "img/usuarios/moviles/habilitarUsuario.png",
                descripcion: "Mensaje de confirmación para habilitar un usuario"
            },
            {
                nombre: "Mensaje de exito al deshabilitar",
                url: "img/usuarios/exitoHabilitar.png",
                descripcion: ""
            }
        ]
    }),
    methods: {
        actualizarVista(val) {
            this.plataforma = val;
        }
    }
}
</script>